import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import Tabs, { Tab } from "react-best-tabs";
import "react-best-tabs/dist/index.css";
import ChatSupportBtn from "./ChatSupportBtn";
import "antd/dist/antd.css";
import { Switch, Space } from "antd";
import { logout } from "./Utility";
import customFetch from "./apicall/api";

class NACH_Preparation_Forpull extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isErrOpen: false,
      api_error_message: "",
      isUpdate: false,
      overdue: [],
      full_satisfied: [],
      partial_satisfied: [],
      full_pending: [],
      hhname: "",
      pull_amt: "",
      pull_amtbkp: "",
      pull_date: "",
      pull_flag: "",
      emi_amt: "",
      isToggled: false,
      loan_id: "",
      loan_number: "",
      isUpdatecnf: false,
      isNachAmtDisabled: true,
      userid: localStorage.getItem("in_userid"),
      reset_flag: false,
      time_flag: 0,
      isActive: 1,
      tab: 1,
      total_os: 0,
      pull_amount_warning: null,
    };
  }
  componentDidMount() {
    this.fetchDetails();
    this.checkTime();
  }

  setDateTime = function(date, str) {
    var sp = str.split(":");
    date.setHours(parseInt(sp[0], 10));
    date.setMinutes(parseInt(sp[1], 10));
    date.setSeconds(parseInt(sp[2], 10));
    return date;
  };

  checkTime() {
    var current = new Date();
    var startTime = this.setDateTime(new Date(current), "22:00:00");
    var endTime = this.setDateTime(new Date(current), "2:00:00");

    console.log(startTime);
    console.log(endTime);
    console.log(current);

    if (current > startTime.getTime() && current < endTime.getTime()) {
      this.state.time_flag = 1;
    } else {
      this.state.time_flag = 0;
    }
  }

  async fetchDetails() {
    if (this.state.isActive === 1) {
      const overdue = await this.fetchpayments(1);
      this.setState({
        overdue: overdue,
      });
    }
    if (this.state.isActive === 2) {
      const full_satisfied = await this.fetchpayments(2);
      this.setState({
        full_satisfied: full_satisfied,
      });
    }
    if (this.state.isActive === 3) {
      const partial_satisfied = await this.fetchpayments(3);
      this.setState({
        partial_satisfied: partial_satisfied,
      });
    }
    if (this.state.isActive === 4) {
      const full_pending = await this.fetchpayments(4);
      this.setState({
        full_pending: full_pending,
      });
    }
    // this.setState(
    //   {
    //     overdue: overdue,
    //     full_satisfied: full_satisfied,
    //     partial_satisfied: partial_satisfied,
    //     full_pending: full_pending,
    //   },
    //   function () {
    //     const $ = window.$;
    //     $("#findash").DataTable();
    //     $("#findash_full_satisfied").DataTable();
    //     $("#findash_partial_satisfied").DataTable();
    //     $("#findash_full_pending").DataTable();
    //   }
    // );
  }
  async fetchpayments(input_flag) {
    try {
      const { api_token } =
        (this.props.location && this.props.location.state) || {};
      // AT-2143 | AT-2179 | Ankur Makavana | 13-07-2023 | conver post method to get method
      const params = {
        input_flag: input_flag,
      };
      const queryParams = new URLSearchParams(params).toString();
      const response = await customFetch(
        process.env.REACT_APP_URL + "/get/customer/overduecases?" + queryParams,
        {
          method: "GET",
          headers: { "api-token": api_token },
        }
      );

      if (response.headers.get("api_code") > 0) {
        this.setState({
          isErrOpen: true,
          api_error_message: response.headers.get("api_error_message"),
        });
      }

      const data = await response.json();

      if (data.api_code === 4 || data.api_code === 3 || data.api_code === 5) {
        localStorage.clear();
        this.props.history.push("/");
      }
      return data;
    } catch (error) {
      console.log("error", error);
    }
  }

  updpull(
    hhname,
    pull_amt,
    pull_date,
    pull_flag,
    loan_id,
    loan_number,
    isNachAmtDisabled,
    emi_amt,
    reset_flag,
    total_os
  ) {
    this.setState({
      isUpdate: true,
      hhname: hhname,
      pull_amt: pull_amt,
      pull_amtbkp: pull_amt,
      pull_date: pull_date,
      pull_flag: pull_flag,
      loan_id: loan_id,
      loan_number: loan_number,
      isNachAmtDisabled: isNachAmtDisabled,
      emi_amt: emi_amt,
      reset_flag: reset_flag,
      total_os: total_os,
    });
  }
  // handelChange = (checked) => {
  //   console.log(checked);
  //   this.setState({
  //     pull_flag: checked ? 1 : 0,
  //   });
  // };
  async updatedata() {
    try {
      const { api_token } =
        (this.props.location && this.props.location.state) || {};
      const formdata = new FormData();
      formdata.append("loan_id", this.state.loan_number);
      formdata.append("nach_pull_flag", this.state.pull_flag);
      formdata.append("next_pull_amount", this.state.pull_amt);
      formdata.append("userid", this.state.userid);
      formdata.append("reset_flag", this.state.reset_flag);
      formdata.append(
        "next_pull_date",
        moment(this.state.pull_date).format("YYYY-MM-DD")
      );

      const response = await customFetch(
        process.env.REACT_APP_URL + "/set/customer/nach_details",
        {
          method: "POST",
          headers: { "api-token": api_token },
          body: formdata,
        }
      );
      const data = await response.json();

      if (data.api_code === 4 || data.api_code === 3 || data.api_code === 5) {
        localStorage.clear();
        this.props.history.push("/");
      }

      // this.setState({
      //   isErrOpen: true,
      //   api_error_message: data.message,
      //   isUpdatecnf: false,
      // });

      this.updateresondata();
      this.fetchDetails();
    } catch (e) {
      console.error(e);
    }
  }
  async updateresondata() {
    try {
      const { api_token } =
        (this.props.location && this.props.location.state) || {};
      const uid = localStorage.getItem("in_userid");
      const formdata = new FormData();
      formdata.append("loan_documentation_id", this.state.loan_number);
      formdata.append(
        "next_pull_date",
        moment(this.state.pull_date).format("YYYY-MM-DD")
      );
      formdata.append("next_pull_amount", this.state.pull_amt);
      formdata.append("remark", this.state.remark);
      formdata.append("added_by", uid);
      formdata.append("approved_by", uid);
      formdata.append("approver_remark", this.state.remark);
      const response = await customFetch(
        process.env.REACT_APP_URL + "/set/nach/pull/change",
        {
          method: "POST",
          headers: { "api-token": api_token },
          body: formdata,
        }
      );

      const data = await response.json();

      if (data.api_code === 4 || data.api_code === 3 || data.api_code === 5) {
        localStorage.clear();
        this.props.history.push("/");
      }
      this.setState({
        isErrOpen: true,
        api_error_message: data.message,
        isUpdatecnf: false,
        reason: "",
      });
    } catch (e) {
      console.log(e);
    }
  }
  handleTabClick = (event, tab) => {
    this.setState({ isActive: tab }, function() {
      this.fetchDetails();
    });
  };
  handleInputAmount = (e) => {
    if (Number(e.target.value) <= this.state.total_os) {
      this.setState({ pull_amount_warning: null });
    }
    if (
      isNaN(e.target.value) ||
      Number(e.target.value) == 0 ||
      e.target.value[0] === "0"
    ) {
      this.setState({ pull_amount_warning: "Invalid amount" });
    }
    if (Number(e.target.value) >= this.state.total_os) {
      this.setState({
        pull_amount_warning:
          "Amount cannot be greater than " + this.state.total_os,
      });
    }

    this.setState({ pull_amt: e.target.value });
  };
  render() {
    const {
      api_error_message,
      isErrOpen,
      isUpdate,
      overdue,
      isUpdatecnf,
    } = this.state;
    const { api_token } =
      (this.props.location && this.props.location.state) || {};

    return (
      <>
        <div
          className={
            isUpdatecnf
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.setState({ isUpdatecnf: false })}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <div className="pull-updateholder">
                <div className="pullab-holder">
                  Confirm Update For <span>{this.state.hhname}</span>.<br />
                  Do you want to update the next pull amount to Rs.{" "}
                  {this.state.pull_amt}?
                </div>
                <div className="row pull-upd">
                  <div className="col-md-4">
                    <span>Next Pull Amount</span>
                    <div className="nextpull-amtupd text-center">
                      {this.state.pull_amt}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <span>Next Pull Date</span>

                    <div className="nextpull-dateupd text-center">
                      {moment(this.state.pull_date).format("DD-MM-YYYY")}
                    </div>
                  </div>

                  {/* <div className="col-md-4">
                    <span>Next Pull flag</span>

                    <span className="next-pullflag">
                      <div className="nextpull-flagupd text-center">
                        {this.state.pull_flag === 0 ? "No" : "Yes"}
                      </div>
                    </span>
                  </div> */}
                  <div className="col-md-12 mt-2">
                    <span>Reason</span>
                    <textarea
                      name="reason"
                      className="form-control"
                      readOnly={true}
                      value={this.state.reason}
                    ></textarea>
                  </div>
                </div>
                <div class="modal-footer text-center">
                  <button
                    type="button"
                    class="btn btn-primary"
                    onClick={() =>
                      this.setState({
                        isUpdatecnf: false,
                        pull_amount_warning: null,
                        reason: "",
                      })
                    }
                  >
                    CANCEL
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    onClick={() => {
                      this.updatedata();
                    }}
                  >
                    SUBMIT
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            isUpdate
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.setState({ isUpdate: false })}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <div className="pull-updateholder">
                <div className="pullab-holder">
                  Update For <span>{this.state.hhname}</span>
                </div>
                <div className="row pull-upd">
                  <div className="col-md-4">
                    <span>Next Pull Amount </span>
                    {/* <small class=" text-nowrap text-warning">{"< " + this.state.total_os}</small>  */}
                    <input
                      disabled={this.state.isNachAmtDisabled}
                      name="pull_amt"
                      className="next-pullamt form-control"
                      onChange={this.handleInputAmount}
                      value={this.state.pull_amt}
                    />
                  </div>

                  <div className="col-md-4">
                    <span>Next Pull Date</span>

                    <input
                      type="date"
                      name="pull_date"
                      disabled
                      className="next-pulldate form-control"
                      // defaultValue={moment(pulldata.next_pull_date).format(
                      //   "YYYY-MM-DD"
                      // )}
                      min={`${
                        new Date(Date.now() + 3600 * 1000 * 24)
                          .toISOString()
                          .split("T")[0]
                      }`}
                      onChange={(e) => {
                        this.setState({ pull_date: e.target.value });
                      }}
                      value={moment(this.state.pull_date).format("YYYY-MM-DD")}
                    />
                  </div>
                  <div className="col-md-4 d-flex align-items-end">
                    {this.state.tab == 3 ? (
                      <Space direction="vertical">
                        <Switch
                          checkedChildren="Reset To Balance"
                          unCheckedChildren="Reset To EMI"
                          onChange={(e) => {
                            e
                              ? this.setState({ pull_amt: this.state.emi_amt })
                              : this.setState({
                                  pull_amt: this.state.pull_amtbkp,
                                });
                          }}
                        />
                      </Space>
                    ) : this.state.tab == 2 ? (
                      <Space direction="vertical">
                        <Switch
                          checkedChildren="Reset To EMI"
                          unCheckedChildren="Reset To Zero"
                          onChange={(e) => {
                            e
                              ? this.setState({ pull_amt: 0 })
                              : this.setState({ pull_amt: this.state.emi_amt });
                          }}
                        />
                      </Space>
                    ) : (
                      <button
                        type="button"
                        class="btn btn-primary"
                        onClick={() => {
                          this.setState({
                            pull_amt:
                              this.state.tab == 2 ? 0 : this.state.emi_amt,
                            reset_flag: true,
                          });
                        }}
                      >
                        Reset to EMI
                      </button>
                    )}
                  </div>
                  <small class="text-danger">
                    {this.state.pull_amount_warning
                      ? "*" + this.state.pull_amount_warning
                      : ""}
                  </small>
                  <div className="col-md-12 mt-2">
                    <span>Reason</span>
                    <textarea
                      name="reason"
                      className="form-control"
                      onChange={(e) => {
                        this.setState({ reason: e.target.value });
                      }}
                      defaultValue=""
                    ></textarea>
                  </div>
                </div>
                <div class="modal-footer text-center">
                  <button
                    type="button"
                    class="btn btn-primary"
                    onClick={() =>
                      this.setState({
                        isUpdate: false,
                        pull_amount_warning: null,
                        reason: "",
                      })
                    }
                  >
                    CANCEL
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    disabled={
                      !this.state.reason ||
                      this.state.pull_amount_warning != null
                    }
                    onClick={() =>
                      this.setState({ isUpdate: false, isUpdatecnf: true })
                    }
                  >
                    SUBMIT
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            isErrOpen
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.setState({ isErrOpen: false })}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p>{api_error_message}</p>
            </div>
          </div>
        </div>

        <section className="main-sec">
          <div className="container fix-width">
            <div className="header-area">
              <div
                className="icon_bg"
                onClick={() => this.props.history.goBack()}
              >
                <img
                  src={require("../assets/images/back.png")}
                  className="cso_icon_img"
                  alt=""
                />
              </div>
              <div className="head-title">NACH Preparation For Pull</div>
              <div className="log-out-report">
                <img
                  src={require("../assets/images/power-off.png")}
                  onClick={() => logout()}
                  alt=""
                />
              </div>
            </div>
            {this.state.time_flag == 1 ? (
              <div className="maintaenance-container">
                <div className="maintaenance-image">
                  <img src="data:image/gif;base64,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" />
                </div>
                <br />
                <div class="content">
                  <h3>
                    <span className="maintaenance-text">
                      {" "}
                      Maintenance in progress. This facility will not be
                      available between 9.00 PM to 2.00 AM
                    </span>
                  </h3>
                  <p>Please stand by</p>
                </div>
              </div>
            ) : (
              <Tabs
                activeTab="1"
                className=""
                ulClassName=""
                activityClassName="bg-success"
                onClick={(event, tab) => {
                  this.setState({ tab });
                  this.handleTabClick(event, tab);
                }}
              >
                <Tab title="Overdue" className="mr-3">
                  <div className="mt-3">
                    {this.state.overdue && this.state.overdue.length > 0
                      ? this.state.overdue.map((pulldata, index) => (
                          <div className="card-data" key={index}>
                            <div className="head-data">
                              <div className="head-lid">
                                {pulldata.household_name}
                              </div>
                            </div>
                            <div className="hhdetails">
                              <h2>Details :</h2>
                              <div class="bank-detail">
                                <div class="bankdetail-data">
                                  Household No :
                                  <span class="float-right">
                                    {pulldata.household_number}
                                  </span>
                                </div>
                                <div class="bankdetail-data tb-border">
                                  Loan ID :
                                  <span class="float-right">
                                    {pulldata.loan_id}
                                  </span>
                                </div>
                                <div class="bankdetail-data">
                                  Contact No :
                                  <span class="float-right">
                                    {pulldata.mobile_no}
                                  </span>
                                </div>
                              </div>
                              <h2 className="border-bottom mt-3 pb-1">
                                {pulldata.partner_name}
                              </h2>
                              <div className="amtdataholder">
                                <div className="row container">
                                  <div className="col-4">
                                    <div className="amt-label">EMI</div>
                                    <div className="amtdata amt-emi">
                                      {pulldata.emi}
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="amt-label">
                                      Next Pull Amount
                                    </div>
                                    <div className="amtdata amt-pull">
                                      {pulldata.next_pull_amount}
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="amt-label">
                                      Current Overdue
                                    </div>
                                    <div className="amtdata amt-current">
                                      {pulldata.tot_overdue}
                                    </div>
                                  </div>
                                </div>
                                <div className="row container">
                                  <div className="col-6">
                                    <div className="amt-label">
                                      Next Pull Date
                                    </div>
                                    <div className="amtdata amt-pull">
                                      {moment(pulldata.next_pull_date).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-6">
                                    <div className="amt-label">Co Lending</div>
                                    <div className="amtdata amt-pull">
                                      {pulldata.co_lending_flag}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="updbutton">
                                <button
                                  className="updbtn"
                                  onClick={() =>
                                    this.updpull(
                                      pulldata.household_name,
                                      pulldata.next_pull_amount,
                                      pulldata.next_pull_date,
                                      pulldata.nach_pull_flag,
                                      pulldata.loan_id,
                                      pulldata.loan_number,
                                      false,
                                      pulldata.emi,
                                      false,
                                      pulldata.total_os
                                    )
                                  }
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      : ""}
                    {/* <table className="table table-hover" id="findash">
                      <thead>
                        <tr>
                          <th scope="col">Name</th>
                          <th scope="col">Partner Name</th>
                          <th scope="col">EMI</th>
                          <th scope="col">Next Pull Amount</th>
                          <th scope="col">Current Overdue</th>
                          <th scope="col">Co Lending</th>
                          <th scope="col">Next Pull Date</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.overdue && this.state.overdue.length > 0 ? (
                          this.state.overdue.map((pulldata, index) => (
                            <tr className="nach-pull" key={index}>
                              <td>
                                <div className="name-holder">
                                  <div className="pill-name">
                                    <span>{pulldata.household_name} </span>
                                  </div>
                                  <div className="pull-dataholder">
                                    <span>
                                      Household No : {pulldata.household_number}
                                    </span>
                                    <span>Loan ID : {pulldata.loan_id}</span>
                                    <span>Contact : {pulldata.mobile_no}</span>
                                  </div>
                                </div>
                              </td>
                              <td>{pulldata.partner_name}</td>
                              <td>{pulldata.emi}</td>
                              <td>
                                <div className="nextpull-amtupd text-center">
                                  {pulldata.next_pull_amount}
                                </div>
                              </td>
                              <td>{pulldata.tot_overdue}</td>

                              <td>{pulldata.co_lending_flag}</td>
                              <td>
                                <div className="nextpull-dateupd text-center">
                                  {moment(pulldata.next_pull_date).format(
                                    "DD-MM-YYYY"
                                  )}
                                </div>
                              </td>
                              <td>
                                <button
                                  className="btn btn-primary"
                                  onClick={() =>
                                    this.updpull(
                                      pulldata.household_name,
                                      pulldata.next_pull_amount,
                                      pulldata.next_pull_date,
                                      pulldata.nach_pull_flag,
                                      pulldata.loan_id,
                                      pulldata.loan_number,
                                      false,
                                      pulldata.emi,
                                      false,
                                      pulldata.total_os
                                    )
                                  }
                                >
                                  Update
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <div className="text-center">No Data Found</div>
                        )}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th scope="col">Name</th>
                          <th scope="col">Partner Name</th>
                          <th scope="col">EMI</th>
                          <th scope="col">Next Pull Amount</th>
                          <th scope="col">Current Overdue</th>
                          <th scope="col">Co Lending</th>
                          <th scope="col">Next Pull Date</th>
                          <th scope="col">Action</th>
                        </tr>
                      </tfoot>
                    </table> */}
                  </div>
                </Tab>
                <Tab title="Full Current Demand Satisfied" className="mr-3">
                  <div className="mt-3">
                    {this.state.full_satisfied &&
                    this.state.full_satisfied.length > 0
                      ? this.state.full_satisfied.map((pulldata, index) => (
                          <div className="card-data" key={index}>
                            <div className="head-data">
                              <div className="head-lid">
                                {pulldata.household_name}
                              </div>
                            </div>
                            <div className="hhdetails">
                              <h2>Details :</h2>
                              <div class="bank-detail">
                                <div class="bankdetail-data">
                                  Household No :
                                  <span class="float-right">
                                    {pulldata.household_number}
                                  </span>
                                </div>
                                <div class="bankdetail-data tb-border">
                                  Loan ID :
                                  <span class="float-right">
                                    {pulldata.loan_id}
                                  </span>
                                </div>
                                <div class="bankdetail-data">
                                  Contact No :
                                  <span class="float-right">
                                    {pulldata.mobile_no}
                                  </span>
                                </div>
                              </div>
                              <h2 className="border-bottom mt-3 pb-1">
                                {pulldata.partner_name}
                              </h2>
                              <div className="amtdataholder">
                                <div className="row container">
                                  <div className="col-4">
                                    <div className="amt-label">EMI</div>
                                    <div className="amtdata amt-emi">
                                      {pulldata.emi}
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="amt-label">
                                      Next Pull Amount
                                    </div>
                                    <div className="amtdata amt-pull">
                                      {pulldata.next_pull_amount}
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="amt-label">
                                      Balance Amount
                                    </div>
                                    <div className="amtdata amt-current">
                                      {pulldata.tot_overdue}
                                    </div>
                                  </div>
                                </div>
                                <div className="row container">
                                  <div className="col-6">
                                    <div className="amt-label">
                                      Next Pull Date
                                    </div>
                                    <div className="amtdata amt-pull">
                                      {moment(pulldata.next_pull_date).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-6">
                                    <div className="amt-label">Co Lending</div>
                                    <div className="amtdata amt-pull">
                                      {pulldata.co_lending_flag}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="updbutton">
                                <button
                                  className="updbtn"
                                  onClick={() =>
                                    this.updpull(
                                      pulldata.household_name,
                                      0,
                                      pulldata.next_pull_date,
                                      pulldata.nach_pull_flag,
                                      pulldata.loan_id,
                                      pulldata.loan_number,
                                      false,
                                      pulldata.emi,
                                      false,
                                      pulldata.total_os
                                    )
                                  }
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      : ""}
                    {/* <table
                      className="table table-hover"
                      id="findash_full_satisfied"
                    >
                      <thead>
                        <tr>
                          <th scope="col">Name</th>
                          <th scope="col">Partner Name</th>
                          <th scope="col">EMI</th>
                          <th scope="col">Next Pull Amount</th>
                          <th scope="col">Balance Amount</th>

                          <th scope="col">Co Lending</th>
                          <th scope="col">Next Pull Date</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.full_satisfied &&
                        this.state.full_satisfied.length > 0 ? (
                          this.state.full_satisfied.map((pulldata, index) => (
                            <tr className="nach-pull" key={index}>
                              <td>
                                <div className="name-holder">
                                  <div className="pill-name">
                                    <span>{pulldata.household_name} </span>
                                  </div>
                                  <div className="pull-dataholder">
                                    <span>
                                      Household No : {pulldata.household_number}
                                    </span>
                                    <span>Loan ID : {pulldata.loan_id}</span>
                                    <span>Contact : {pulldata.mobile_no}</span>
                                  </div>
                                </div>
                              </td>
                              <td>{pulldata.partner_name}</td>
                              <td>{pulldata.emi}</td>
                              <td>
                                <div className="nextpull-amtupd text-center">
                                  {pulldata.next_pull_amount}
                                </div>
                              </td>
                              <td>{pulldata.tot_overdue}</td>

                              <td>{pulldata.co_lending_flag}</td>
                              <td>
                                <div className="nextpull-dateupd text-center">
                                  {moment(pulldata.next_pull_date).format(
                                    "DD-MM-YYYY"
                                  )}
                                </div>
                              </td>
                              <td>
                                <button
                                  className="btn btn-primary"
                                  onClick={() =>
                                    this.updpull(
                                      pulldata.household_name,
                                      0,
                                      pulldata.next_pull_date,
                                      pulldata.nach_pull_flag,
                                      pulldata.loan_id,
                                      pulldata.loan_number,
                                      false,
                                      pulldata.emi,
                                      false,
                                      pulldata.total_os
                                    )
                                  }
                                >
                                  Update
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <div className="text-center">No Data Found</div>
                        )}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th scope="col">Name</th>
                          <th scope="col">Partner Name</th>
                          <th scope="col">EMI</th>
                          <th scope="col">Next Pull Amount</th>
                          <th scope="col">Balance Amount</th>

                          <th scope="col">Co Lending</th>
                          <th scope="col">Next Pull Date</th>
                          <th scope="col">Action</th>
                        </tr>
                      </tfoot>
                    </table> */}
                  </div>
                </Tab>
                <Tab title="Partial Current Demand Satisfied" className="mr-3">
                  <div className="mt-3">
                    {this.state.partial_satisfied &&
                    this.state.partial_satisfied.length > 0
                      ? this.state.partial_satisfied.map((pulldata, index) => (
                          <div className="card-data" key={index}>
                            <div className="head-data">
                              <div className="head-lid">
                                {pulldata.household_name}
                              </div>
                            </div>
                            <div className="hhdetails">
                              <h2>Details :</h2>
                              <div class="bank-detail">
                                <div class="bankdetail-data">
                                  Household No :
                                  <span class="float-right">
                                    {pulldata.household_number}
                                  </span>
                                </div>
                                <div class="bankdetail-data tb-border">
                                  Loan ID :
                                  <span class="float-right">
                                    {pulldata.loan_id}
                                  </span>
                                </div>
                                <div class="bankdetail-data">
                                  Contact No :
                                  <span class="float-right">
                                    {pulldata.mobile_no}
                                  </span>
                                </div>
                              </div>
                              <h2 className="border-bottom mt-3 pb-1">
                                {pulldata.partner_name}
                              </h2>
                              <div className="amtdataholder">
                                <div className="row container">
                                  <div className="col-4">
                                    <div className="amt-label">EMI</div>
                                    <div className="amtdata amt-emi">
                                      {pulldata.emi}
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="amt-label">
                                      Next Pull Amount
                                    </div>
                                    <div className="amtdata amt-pull">
                                      {pulldata.next_pull_amount}
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="amt-label">
                                      Balance Amount
                                    </div>
                                    <div className="amtdata amt-current">
                                      {pulldata.balance_amount}
                                    </div>
                                  </div>
                                </div>
                                <div className="row container">
                                  <div className="col-6">
                                    <div className="amt-label">
                                      Next Pull Date
                                    </div>
                                    <div className="amtdata amt-pull">
                                      {moment(pulldata.next_pull_date).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-6">
                                    <div className="amt-label">Co Lending</div>
                                    <div className="amtdata amt-pull">
                                      {pulldata.co_lending_flag}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="updbutton">
                                <button
                                  className="updbtn"
                                  onClick={() =>
                                    this.updpull(
                                      pulldata.household_name,
                                      pulldata.balance_amount,
                                      pulldata.next_pull_date,
                                      pulldata.nach_pull_flag,
                                      pulldata.loan_id,
                                      pulldata.loan_number,
                                      true,
                                      pulldata.emi,
                                      false,
                                      pulldata.total_os
                                    )
                                  }
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      : ""}
                    {/* <table
                      className="table table-hover"
                      id="findash_partial_satisfied"
                    >
                      <thead>
                        <tr>
                          <th scope="col">Name</th>
                          <th scope="col">Partner Name</th>
                          <th scope="col">EMI</th>
                          <th scope="col">Next Pull Amount</th>
                          <th scope="col">Balance Amount</th>

                          <th scope="col">Co Lending</th>
                          <th scope="col">Next Pull Date</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.partial_satisfied &&
                        this.state.partial_satisfied.length > 0 ? (
                          this.state.partial_satisfied.map(
                            (pulldata, index) => (
                              <tr className="nach-pull" key={index}>
                                <td>
                                  <div className="name-holder">
                                    <div className="pill-name">
                                      <span>{pulldata.household_name} </span>
                                    </div>
                                    <div className="pull-dataholder">
                                      <span>
                                        Household No :{" "}
                                        {pulldata.household_number}
                                      </span>
                                      <span>Loan ID : {pulldata.loan_id}</span>
                                      <span>
                                        Contact : {pulldata.mobile_no}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td>{pulldata.partner_name}</td>
                                <td>{pulldata.emi}</td>
                                <td>
                                  <div className="nextpull-amtupd text-center">
                                    {pulldata.next_pull_amount}
                                  </div>
                                </td>

                                <td>{pulldata.balance_amount}</td>
                                <td>{pulldata.co_lending_flag}</td>
                                <td>
                                  <div className="nextpull-dateupd text-center">
                                    {moment(pulldata.next_pull_date).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <button
                                    className="btn btn-primary"
                                    onClick={() =>
                                      this.updpull(
                                        pulldata.household_name,
                                        pulldata.balance_amount,
                                        pulldata.next_pull_date,
                                        pulldata.nach_pull_flag,
                                        pulldata.loan_id,
                                        pulldata.loan_number,
                                        true,
                                        pulldata.emi,
                                        false,
                                        pulldata.total_os
                                      )
                                    }
                                  >
                                    Update
                                  </button>
                                </td>
                              </tr>
                            )
                          )
                        ) : (
                          <div className="text-center">No Data Found</div>
                        )}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th scope="col">Name</th>
                          <th scope="col">Partner Name</th>
                          <th scope="col">EMI</th>
                          <th scope="col">Next Pull Amount</th>
                          <th scope="col">Balance Amount</th>

                          <th scope="col">Co Lending</th>
                          <th scope="col">Next Pull Date</th>
                          <th scope="col">Action</th>
                        </tr>
                      </tfoot>
                    </table> */}
                  </div>
                </Tab>
                <Tab title="Full Current Demand Pending" className="mr-3">
                  <div className="mt-3">
                    {this.state.full_pending &&
                    this.state.full_pending.length > 0
                      ? this.state.full_pending.map((pulldata, index) => (
                          <div className="card-data">
                            <div className="head-data">
                              <div className="head-lid">
                                {pulldata.household_name}
                              </div>
                            </div>
                            <div className="hhdetails">
                              <h2>Details :</h2>
                              <div class="bank-detail">
                                <div class="bankdetail-data">
                                  Household No :
                                  <span class="float-right">
                                    {pulldata.household_number}
                                  </span>
                                </div>
                                <div class="bankdetail-data tb-border">
                                  Loan ID :
                                  <span class="float-right">
                                    {pulldata.loan_id}
                                  </span>
                                </div>
                                <div class="bankdetail-data">
                                  Contact No :
                                  <span class="float-right">
                                    {pulldata.mobile_no}
                                  </span>
                                </div>
                              </div>
                              <h2 className="border-bottom mt-3 pb-1">
                                {pulldata.partner_name}
                              </h2>
                              <div className="amtdataholder">
                                <div className="row container">
                                  <div className="col-6">
                                    <div className="amt-label">EMI</div>
                                    <div className="amtdata amt-emi">
                                      {pulldata.emi}
                                    </div>
                                  </div>
                                  <div className="col-6">
                                    <div className="amt-label">
                                      Next Pull Amount
                                    </div>
                                    <div className="amtdata amt-pull">
                                      {pulldata.next_pull_amount}
                                    </div>
                                  </div>
                                </div>
                                <div className="row container">
                                  <div className="col-6">
                                    <div className="amt-label">
                                      Next Pull Date
                                    </div>
                                    <div className="amtdata amt-pull">
                                      {moment(pulldata.next_pull_date).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-6">
                                    <div className="amt-label">Co Lending</div>
                                    <div className="amtdata amt-pull">
                                      {pulldata.co_lending_flag}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      : ""}
                    {/* <table
                      className="table table-hover"
                      id="findash_full_pending"
                    >
                      <thead>
                        <tr>
                          <th scope="col">Name</th>
                          <th scope="col">Partner Name</th>
                          <th scope="col">EMI</th>
                          <th scope="col">Next Pull Amount</th>

                          <th scope="col">Co Lending</th>
                          <th scope="col">Next Pull Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.full_pending &&
                        this.state.full_pending.length > 0 ? (
                          this.state.full_pending.map((pulldata, index) => (
                            <tr className="nach-pull" key={index}>
                              <td>
                                <div className="name-holder">
                                  <div className="pill-name">
                                    <span>{pulldata.household_name} </span>
                                  </div>
                                  <div className="pull-dataholder">
                                    <span>
                                      Household No : {pulldata.household_number}
                                    </span>
                                    <span>Loan ID : {pulldata.loan_id}</span>
                                    <span>Contact : {pulldata.mobile_no}</span>
                                  </div>
                                </div>
                              </td>
                              <td>{pulldata.partner_name}</td>
                              <td>{pulldata.emi}</td>
                              <td>
                                <div className="nextpull-amtupd text-center">
                                  {pulldata.next_pull_amount}
                                </div>
                              </td>

                              <td>{pulldata.co_lending_flag}</td>
                              <td>
                                <div className="nextpull-dateupd text-center">
                                  {moment(pulldata.next_pull_date).format(
                                    "DD-MM-YYYY"
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <div className="text-center">No Data Found</div>
                        )}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th scope="col">Name</th>
                          <th scope="col">Partner Name</th>
                          <th scope="col">EMI</th>
                          <th scope="col">Next Pull Amount</th>

                          <th scope="col">Co Lending</th>
                          <th scope="col">Next Pull Date</th>
                        </tr>
                      </tfoot>
                    </table> */}
                  </div>
                </Tab>
              </Tabs>
            )}
          </div>
        </section>
        <ChatSupportBtn history={this.props.history} />
      </>
    );
  }
}

export default withRouter(NACH_Preparation_Forpull);
